export const isAlphanumeric = (code: number) => {
  return (
    (code > 47 && code < 58) || // numeric (0-9)
    (code > 64 && code < 91) || // upper alpha (A-Z)
    (code > 96 && code < 123) // lower alpha (a-z)
  )
}

export const getInitials = (name: string | null) => {
  if (!name) {
    return 'U'
  }

  const [firstName, lastName] = name
    .split(' ')
    .filter((word) => isAlphanumeric(word.charCodeAt(0)))

  if (!firstName) {
    return 'U'
  }

  return lastName
    ? `${firstName.charAt(0)}${lastName?.charAt(0)}`
    : firstName.charAt(0)
}

export const format = (
  str: `${string}%s${string}`,
  ...args: unknown[]
): string => {
  let argIndex = 0

  return str.replace(/%s/g, () => String(args[argIndex++]))
}
